import { ButtonLink, RichText, Stack } from '@ads-core/components';
import { ArrowRightIcon } from '@ads-core/icons';
import { ButtonProps } from '@alliander-fe/sitecore-types';
import { useTrackingContext } from '@liander/context';

export const ConclusionBlock = ({
  text,
  primaryButton,
  secondaryButton,
}: {
  text?: string;
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
}) => {
  const { trackPageInteraction } = useTrackingContext();
  if (!text) return null;

  return (
    <>
      {text ? <RichText tone="onDark">{text}</RichText> : null}
      {primaryButton?.text || secondaryButton?.text ? (
        <Stack direction="row" wrap gap={4}>
          {primaryButton?.text ? (
            <ButtonLink
              variant="secondary"
              {...primaryButton}
              afterIcon={<ArrowRightIcon size="xs" />}
              asChild
              onClick={() =>
                trackPageInteraction({
                  actionDetail: primaryButton.text ?? '',
                  actionType: 'button_click',
                })
              }
            >
              {primaryButton.text}
            </ButtonLink>
          ) : null}
          {secondaryButton?.text ? (
            <ButtonLink
              variant="ghostOnDark"
              {...secondaryButton}
              afterIcon={<ArrowRightIcon size="xs" />}
              asChild
              onClick={() =>
                trackPageInteraction({
                  actionDetail: secondaryButton.text ?? '',
                  actionType: 'button_click',
                })
              }
            >
              {secondaryButton.text}
            </ButtonLink>
          ) : null}
        </Stack>
      ) : null}
    </>
  );
};
